export default "__VITE_ASSET__DJo4mTpe__"